import React from "react";
import s from "./PartnersPage.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Link } from "react-router-dom";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Marquee from "react-fast-marquee";

const PartnersPage = () => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const partners = useSelector((state) => state.application.partners);
  const dispatch = useDispatch();
  return (
    <div>
      {width > 970 ? <Header /> : <MobileHeader />}
      <h2 className={s.h2}>{t("partners")}</h2>
      <div className={s.content}>
        <Marquee speed={30} pauseOnHover={true} className={s.marquee}>
          {partners.map((it, index) => (
            <a
              key={index}
              href={it.url}
              target="_blank"
              rel="noopener noreferrer"
              className={s.slide}
            >
              <img
                src={it.partner_logo}
                className={s.img}
                style={{ height: "45px", marginTop: "10px" }}
                alt={it.title}
              />
            </a>
          ))}
        </Marquee>
      </div>

      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default PartnersPage;
